var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_136_826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_136_826",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_136_826",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_136_826",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEV0lEQVR4nO2dXahlYxjH/+Mz+ZYIpXwTuZEko0GMbT/PPkPZF2JKysTZz7P3HEIjOi7dulBuhpJS1BSSMkgumAvDhUhEJOV7QkbDzCytd5yznRlz9jpnv2u966z9/9Vzdc4+a63nt9f/fc/6BAghhBBCCCGEFOeyDYdDfT3En4baZrTtDqyZPWwJf4FEo9M/FWrboJ4tKLH3ws9IhXSmz4XaZwfImJfiX6I9uIhOqkB7V0Lsx4PKGNYvUF9DKWUifivU/ywgYy6+dkH8dkopRUZvALE9hWUMay/EH6OUWHS7h0L8yWWI2K9sc5iVkTG44f6jIf7K+DLmB/vX0fLj6GQ53LjxNIhvjyZjKGV7+NtLQe49EW1vhVo3OGHyhHamL4bY19FlDOursIwiiG+C2M7/TBR2QvwhTAwduw5iO0qUMdfYHWFZi9F2X2RMmkbj0fwwiO0qXcZQSr6s9QedTKj9sMhnvwu/01jEHg1T1KpkDGtvWPYB67Px7JGf7dhZaBz5wUDxpxKIyBZ+4/2ZBdPifIwZKaTgOLRi6E4fA7VXk8vQ+Rh6A9dvOH4yhUz1TofYB8kl6P5lH0H7Z06WEOlfUvK0NhtvT/Fvw7mViRCivhZqvyZvuo7cU/5uvpCO3Qn1v9I32+PUChayKhxxTd1ApRCgO3sExJ5N3jylEGDqgWOh9lryximFADJzBtQ+TN40pZD8ipBLofZN8oYpheT/Y7Qh/nvyZmkVQuw21Brxuxo1rdURJb67rofhmzmt1cJinsDs7CGoBS0/EmrPJW+Kpi57Ed2Zo9LKyM81i72dvhlejxJ/F3rfyWlk5Cdn1D5J3gStWYl/DumfV60M7V8eTmGm3nitaYn/hI5dVY2M/FIYsd+Sb7TWvMT/gPSmypUhdnehw9Ks7F8pu8OVKyUw2dNardO0eN+09vnkG6UrvWzL+NPitTMnQf2d9BvjDSnbhlvuOWV5MvLrksQ+Tb8R3rCyLzA1uGBpMtqDKyD+ffqV94aW/Qyxq4vJ0P7qBRcXs7JSehB63F9dQIhvpQSv6ou4dbQQsZcpxKsS8lKBPcQuDDe1LO9+PpYWiqs9UHsfN/XOR3TEuhThc43uxm8whWRjDNQUgjrFJIV4egkU4ukbTyGevtkU4ukbTCGevqkU8r9NeCHMWMqsfBkUUjSLvfyn95RxBrSx016hEApR7iHcQ0qBkZVxDIkBB3UO6tXAyMoYWTFgZDGyqoGRlTGyYsDIYmRVAyMrY2TFgJHFyKoGRlbGyIoBI4uRVQ2MrIyRFQNGFiOrGhhZGSMrBo2NrI6vK+EyoE2lr7fYw9HXO+9FcvJHEUUX0iv5oS3h1r2bo693y89BLchvXoy3239cyevtwouNYz7vy7agNuRPllN7K4qMVoXfsn3v1B1fiviboQc1YxXafi3EHoTa40usR6DeSfLix3yZeUSGdVjieufbKr1rwrYTQgghhBBCCCGEEILJ4h9KhyP2YMHnOwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePage1);
export default __webpack_public_path__ + "static/media/Home Page-1.643bf9e2ad562e2a974082be79d14c13.svg";
export { ForwardRef as ReactComponent };